<template>
    <UiCard class="sim-file-download"
            small
    >
        <span>
            {{ name }}
        </span>
        <a :href="downloadUrl" class="sim-file-download__link sim-ghost-btn-hover sim-ghost-btn-hover--alt" download>
            {{ $t('product.download') }}
            <IconDownload size="xs" />
        </a>
    </UiCard>
</template>

<script lang="ts" setup>

const {
    name,
    downloadUrl,
} = defineProps<{
    name: string
    downloadUrl: string
}>()

</script>

<style lang="scss" scoped>

.sim-file-download {
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 0 0 0 1.25rem;

    @include sim-text-normal;
    @include sim-font-medium;

    overflow: hidden;
}

.sim-file-download__link {
    padding: 1rem 1.25rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: $sim-c-simplo;
}

</style>
